import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

/**
 * FeatureCard — Clean, minimal card for feature blocks.
 *
 * Props:
 * - icon: React node — Icon element
 * - title: string — Card title
 * - children: node — Card body content
 * - sx: object — Additional sx props
 */
const FeatureCard = ({ icon, title, children, sx = {} }) => {
  return (
    <Card
      sx={{
        height: '100%',
        p: 0.5,
        ...sx,
      }}
    >
      <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
        {icon && (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 40,
              height: 40,
              borderRadius: 2,
              bgcolor: 'primary.main',
              color: 'primary.contrastText',
              mb: 2,
              '& svg': {
                fontSize: '1.25rem',
              },
            }}
          >
            {icon}
          </Box>
        )}
        {title && (
          <Typography
            variant="h6"
            component="h3"
            sx={{ mb: 1.5, color: 'text.primary' }}
          >
            {title}
          </Typography>
        )}
        <Typography variant="body2" component="div" sx={{ color: 'text.description' }}>
          {children}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default FeatureCard;
